import React, { forwardRef, memo } from 'react'

const UserPlusIcons = forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg
      ref={ref}
      width="47.6"
      height="47.6"
      viewBox="0 0 68 68"
      fill="none"
      {...props}>
      <circle cx="34" cy="34" r="34" fill="#78BE20" />
      <g
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
        clipPath="url(#clip0_2047_4866)">
        <path d="M31.5 38c4.1421 0 7.5-3.3579 7.5-7.5S35.6421 23 31.5 23 24 26.3579 24 30.5 27.3579 38 31.5 38Z" />
        <path d="M21 43c2.5687-3.0563 6.195-5 10.5-5s7.9313 1.9437 10.5 5" />
        <path d="M46 37a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" />
        <path d="M46 33v-1.5" />
        <path d="M44.2675 34 42.9688 33.25" />
        <path d="M44.2675 36 42.9688 36.75" />
        <path d="M46 37v1.5" />
        <path d="M47.7324 36 49.0312 36.75" />
        <path d="M47.7324 34 49.0312 33.25" />
      </g>
      <defs>
        <clipPath id="clip0_2047_4866">
          <rect
            width="32"
            height="32"
            fill="white"
            transform="translate(18 18)"
          />
        </clipPath>
      </defs>
    </svg>
  )
)

UserPlusIcons.displayName = 'UserPlusIcons'

export default memo(UserPlusIcons)
